import React from "react";
import "./policy.css"; // Create this file for CSS styling

const Policy = () => {
  return (
    <div className="policy-container">
              <h2 className="policy-heading text-center mt-5"> Refund and Cancellation Policy</h2>


      {/* Refund and Cancellation */}
      <div className="policy-section">
        <h3>Refund and Cancellation for Service Provider Company</h3>
        <p>
          Due to service providers in nature <b>“NO REFUND”</b>,{" "}
          <b>“NO CANCELLATION”</b> will be entertained once the Payment has been
          made.
        </p>
      </div>

      
      

      {/* Contact Us */}
      <div className="policy-section contact-us">
        <h3>Contact Us</h3>
        <p>
          <b>BION TECHNOLOGY SOLUTION</b>
          <br />
           #3 KCT Tech Park,
           Athipalayam Road,
           Coimbatore - 641049
          <br />
           +91 8883513557
          <br />
           biontechnologysolutionbts@gmail.com
        </p>
      </div>
    </div>
  );
};

export default Policy;
